import { string } from "yup";
const requiredFieldMessage = "This field is required.";
//---------- email validation --------------
export const invalidEmailMessage = "Please enter a valid email address";
export const validEmailRegex = /^[A-Za-z0-9+._-]+@([A-Za-z0-9-]+\.)+[A-Za-z0-9]{2,}$/i;
export const emailValidationSchema = string()
    .matches(validEmailRegex, invalidEmailMessage)
    .required(requiredFieldMessage);
